import { useCallback, useEffect, useState } from "react";

const SECTION_HEADER_BASE_CLASS =
  "tw-bg-secondary/50 tw-py-3.5 tw-px-3.5 tw-rounded-t-lg";

export const useCultivarSectionAccordion = (
  sectionsDisabled = false,
  initialOpen = false
) => {
  const [accordionEnabled, setAccordionEnabled] = useState(initialOpen);

  useEffect(() => {
    if (sectionsDisabled) {
      setAccordionEnabled(false);
    }
  }, [sectionsDisabled]);

  const toggleAccordion = useCallback(() => {
    if (sectionsDisabled) {
      return;
    }

    setAccordionEnabled(prev => !prev);
  }, [sectionsDisabled]);

  const headerClassName = sectionsDisabled
    ? `${SECTION_HEADER_BASE_CLASS} tw-opacity-50 tw-cursor-not-allowed`
    : `${SECTION_HEADER_BASE_CLASS} tw-cursor-pointer`;

  return {
    accordionEnabled,
    toggleAccordion,
    headerClassName
  };
};
